import React from "react";
import { MLSComplianceText } from "./MLSComplianceText";
import { UseQueryResult } from "@tanstack/react-query";

interface MLSProperty {
  mlsNumber: string;
  mlsBoardCode?: string;
}

interface MLSComplianceResponse {
  status: string;
  data: {
    mlsBoardCode: string;
    mlsLogo: string;
    complianceText: string;
  };
}

interface ComplianceFooterProps {
  className?: string;
  properties?: MLSProperty[];
  timestamp?: string;
  mlsComplianceQueries?: UseQueryResult<MLSComplianceResponse, Error>[];
}

const ComplianceFooter: React.FC<ComplianceFooterProps> = ({
  className = "",
  properties = [],
  timestamp,
  mlsComplianceQueries,
}) => {
  return (
    <div className={`mt-10 ${className}`}>
      <div className="py-5 border-t border-gray-200">
        <MLSComplianceText
          mlsBoardCodes={properties.map((p) => p.mlsBoardCode || "")}
          timestamp={timestamp}
          mlsComplianceQueries={mlsComplianceQueries}
        />
      </div>
    </div>
  );
};

export default ComplianceFooter;
